import React, { useState } from 'react';
import { Upload, Button, Space, message } from 'antd';
import { FileExcelOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import { parseExcelFile } from '../../../utils/xlsxParser';
import ImportPreview from './importPreview';

const ImportForm = ({ onSubmit, expectedFields }) => {
  const [data, setData] = useState([]);
  const [fileName, setFileName] = useState(null);

  const beforeUpload = async (file) => {
    try {
      const parsed = await parseExcelFile(file);

      if (!parsed.length) {
        message.warning('No data found in file.');
        return Upload.LIST_IGNORE;
      }

      const keys = Object.keys(parsed[0]);
      const missingFields = expectedFields.filter(field => !keys.includes(field));

      if (missingFields.length) {
        message.error(`Missing required fields: ${missingFields.join(', ')}`);
        return Upload.LIST_IGNORE;
      }
      const normalizeKeys = (row) => 
        Object.fromEntries(
          Object.entries(row).map(([key, value]) => [
            key.trim().toLowerCase().replace(/\s+/g, '_'),
            value,
          ])
        );
      
      const normalizedData = parsed.map(normalizeKeys);
      setData(normalizedData);
      setFileName(file.name);
    } catch (err) {
      message.error('Failed to parse file.');
    }
    return false; // prevent upload
  };

  const handleRemoveFile = () => {
    setData([]);
    setFileName('');
  };

  const handleDownloadTemplate = () => {
    // this points to public/templates/product-template.xlsx
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/templates/product-template.xlsx`;
    link.setAttribute('download', 'product-template.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Space className='mb-16'>
        <Upload
          beforeUpload={beforeUpload}
          showUploadList={false}
          accept=".xlsx, .xls"
          multiple={false}
        >
          <Button icon={<FileExcelOutlined />} >Upload Excel File</Button>
        </Upload>
        <Button icon={<DownloadOutlined />} onClick={handleDownloadTemplate} >Download the template</Button>
      </Space>
      

      {fileName && (
        <div>
          <Space className='mb-16'>
            <h4 className='mb-0'>Preview: {fileName}</h4>
            <Button
              type="link"
              icon={<DeleteOutlined />}
              onClick={handleRemoveFile}
            >
              Clear
            </Button>
          </Space>
          <ImportPreview data={data} setData={setData} onSubmit={onSubmit}/>
        </div>
      )}
    </div>
  );
};

export default ImportForm;
